import React, { Fragment } from 'react';
import { fetchAnalysisAuditById, patchAnalysisReview } from '../state/actions/AnalysisActions';

import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { VALID_ANALYSIS_STATUSES } from '../../helpers/Analysis';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class ReassignAnalysis extends React.PureComponent {
    static propTypes = {
        analysisId: PropTypes.string,
        currStatus: PropTypes.string,
        currUid: PropTypes.string,
        prevStatus: PropTypes.string,
        prevUid: PropTypes.string,
        statusChangeDescription: PropTypes.string,
        patchAnalysisReview: PropTypes.func,
        fetchAnalysisAuditById: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.status = React.createRef();
        this.analystUid = React.createRef();
    }

    reassign = () => {
        const { patchAnalysisReview, fetchAnalysisAuditById } = this.props;

        const { analysisId } = this.props;
        const { value: analysisStatus } = this.status.current;
        const { value: analystUid } = this.analystUid.current;

        patchAnalysisReview({ analysisId, analystUid, analysisStatus })
            .then(() => {
                fetchAnalysisAuditById(analysisId);
            })
            .catch(error => {
                Swal({
                    title: 'Oops...',
                    text: error.message,
                    type: 'error',
                });
            });
    };

    render() {
        const { currStatus: currentStatus, currUid: currentAnalystId } = this.props;
        const {
            prevStatus: previousStatus,
            prevUid: previousAnalystId,
            statusChangeDescription,
        } = this.props;

        const statuses = Object.keys(VALID_ANALYSIS_STATUSES);
        return (
            <Fragment>
                <div className="mb-3">
                    <strong>Status Prior to Review:</strong> {previousStatus}
                    <br />
                    <strong>Analyst Prior to Review:</strong> {previousAnalystId}
                    <br />
                    <strong>Reason Review Requested:</strong> {statusChangeDescription}
                </div>
                <div>
                    <strong className="pr-1">Current Status:</strong>
                    <select ref={this.status} defaultValue={currentStatus}>
                        {statuses.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                    <br />
                    <strong className="pr-1">Current Analyst ID:</strong>
                    <input
                        className="mr-2"
                        ref={this.analystUid}
                        type="email"
                        defaultValue={currentAnalystId}
                    />
                    <button
                        className="btn btn-secondary"
                        onClick={() => {
                            this.analystUid.current.value = '';
                        }}
                    >
                        Remove Analyst Assignment
                    </button>
                    <br />
                    <div className="form-group row d-flex justify-content-end">
                        <button className="btn btn-primary" onClick={this.reassign}>
                            Reassign
                        </button>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => state.analysis;

const mapDispatchToProps = dispatch =>
    bindActionCreators({ patchAnalysisReview, fetchAnalysisAuditById }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReassignAnalysis);
